module.exports = __webpack_public_path__ + "img/mc.fe2e9f3b.svg";